import React, { useRef, useState } from 'react';
import { Alert, TextField } from '@mui/material';
import ModalTitleContainer from '../../../../components/Modal/components/ModalTitleContainer';
import { StyledButton } from '../../../../components/Buttons/DefaultButton/DefaultButton.styles';
import { JobWithInvoiceProps } from '../InvoicePage';
import Api from '../../../../api';

const methods = ['e-transfer', 'cheque', 'direct deposit', 'PayPal', 'other'] as const;
export const InvoiceAlreadyPaidModal = ({ job, onCloseButtonClick, onPaid, isCurrent = () => true }: {
  job: JobWithInvoiceProps; onCloseButtonClick: (e?: any) => void; onPaid: (e?: any) => void;
  isCurrent?: () => boolean;
}) => {
  const [method, setMethod] = useState<typeof methods[number] | ''>('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const submit = async () => {
    if (!isCurrent() || inFlight.current || !method || note.trim().length > 500) return;
    inFlight.current = true;
    setLoading(true);
    setError('');
    try {
      await Api.updateAlreadyPaidInvoice({ invoiceId: job.invoice.id, paidMethod: method, paidNote: note.trim() });
      if (!isCurrent()) return;
      onPaid();
    } catch (e: any) {
      if (!isCurrent()) return;
      setError(e?.body?.message || e?.message || 'Unable to mark this invoice paid. Refresh its status before trying again.');
    } finally { inFlight.current = false; if (isCurrent()) setLoading(false); }
  };
  return <>
    <ModalTitleContainer title="How did you pay this invoice?" onClose={loading ? () => undefined : onCloseButtonClick} />
    <label htmlFor="invoice-office-paid-method">Payment method</label>
    <select id="invoice-office-paid-method" data-testid="invoice-office-paid-method" value={method} disabled={loading}
      onChange={e => setMethod(e.target.value as typeof method)} style={{ display: 'block', width: '100%', minHeight: 44, margin: '8px 0 16px', fontSize: 16 }}>
      <option value="">Select a payment method</option>
      {methods.map(value => <option key={value} value={value}>{value}</option>)}
    </select>
    <TextField label="Add a note (optional)" value={note} onChange={e => setNote(e.target.value)} disabled={loading}
      fullWidth multiline minRows={2} inputProps={{ maxLength: 500, 'data-testid': 'invoice-office-paid-note-input' }} />
    {error && <Alert severity="error">{error}</Alert>}
    <StyledButton data-testid="invoice-office-mark-paid" variant="contained" color="primary" size="large"
      disabled={!method || loading} onClick={submit}>{loading ? 'Saving…' : 'Mark as paid'}</StyledButton>
    <StyledButton data-testid="invoice-office-mark-paid-cancel" variant="outlined" color="primary" size="large"
      disabled={loading} onClick={onCloseButtonClick}>Cancel</StyledButton>
  </>;
};
